import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container mx-auto px-3 py-6 sm:px-4 sm:py-8" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-16"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center py-16"
}
const _hoisted_4 = {
  key: 2,
  class: "text-center py-16"
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { class: "flex items-center justify-between mb-6" }
const _hoisted_7 = { class: "text-gray-600 dark:text-gray-300" }
const _hoisted_8 = { class: "flex items-center space-x-2 bg-gray-100 dark:bg-gray-800 rounded-lg p-1" }

import { ref, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import WallpaperGrid from '../components/WallpaperGrid.vue';
import { wallpaperService, type Wallpaper } from '../firebase/services/wallpaperService';
import { userService } from '../firebase/services/userService';
import { useAuth } from '../composables/useAuth';


export default /*@__PURE__*/_defineComponent({
  __name: 'Favorites',
  setup(__props) {

const router = useRouter();

// State
const viewMode = ref('grid'); // 'grid' or 'preview'
const favoriteWallpapers = ref<Wallpaper[]>([]);
const loading = ref(false);
const { currentUser } = useAuth();

// Methods
const loadFavoriteWallpapers = async () => {
  if (!currentUser.value) {
    favoriteWallpapers.value = [];
    return;
  }
  
  loading.value = true;
  try {
    const favorites = await userService.getUserFavorites(currentUser.value.uid);
    const wallpaperPromises = favorites.map(fav => wallpaperService.getWallpaperById(fav.wallpaperId));
    const wallpapers = await Promise.all(wallpaperPromises);
    favoriteWallpapers.value = wallpapers.filter(w => w !== null) as Wallpaper[];
  } catch (error) {
    console.error('Error loading favorite wallpapers:', error);
  } finally {
    loading.value = false;
  }
};

const viewWallpaper = (wallpaper: Wallpaper) => {
  router.push(`/wallpaper/${wallpaper.id}`);
};

// Lifecycle
onMounted(async () => {
  await loadFavoriteWallpapers();
});

watch(currentUser, async () => {
  await loadFavoriteWallpapers();
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-6 sm:mb-8" }, " Your Favorites ", -1)),
    (!_unref(currentUser))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[2] || (_cache[2] = [
          _createStaticVNode("<svg class=\"w-16 h-16 mx-auto mb-4 text-gray-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z\"></path></svg><h3 class=\"text-lg font-medium text-gray-900 dark:text-white mb-2\">Sign in to save favorites</h3><p class=\"text-gray-500 dark:text-gray-400 mb-6\">Create an account to save your favorite wallpapers</p><button class=\"px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-semibold transition-colors\"> Sign In </button>", 4)
        ])))
      : (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "animate-spin w-8 h-8 border-4 border-purple-500 border-t-transparent rounded-full mx-auto mb-4" }, null, -1),
            _createElementVNode("p", { class: "text-gray-500 dark:text-gray-400" }, "Loading your favorites...", -1)
          ])))
        : (favoriteWallpapers.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[5] || (_cache[5] = _createElementVNode("svg", {
                class: "w-16 h-16 mx-auto mb-4 text-gray-400",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                })
              ], -1)),
              _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 dark:text-white mb-2" }, "No favorites yet", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-gray-500 dark:text-gray-400 mb-6" }, "Start exploring and save wallpapers you love", -1)),
              _createVNode(_component_router_link, {
                to: "/categories",
                class: "inline-block px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-semibold transition-colors"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Browse Wallpapers ", -1)
                ])),
                _: 1,
                __: [4]
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(favoriteWallpapers.value.length) + " favorite" + _toDisplayString(favoriteWallpapers.value.length !== 1 ? 's' : ''), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (viewMode.value = 'grid')),
                    class: _normalizeClass([
            'px-3 py-1 text-sm rounded-md transition-colors',
            viewMode.value === 'grid'
              ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
          ])
                  }, " Grid ", 2),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (viewMode.value = 'preview')),
                    class: _normalizeClass([
            'px-3 py-1 text-sm rounded-md transition-colors',
            viewMode.value === 'preview'
              ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
          ])
                  }, " Device Preview ", 2)
                ])
              ]),
              _createVNode(WallpaperGrid, {
                wallpapers: favoriteWallpapers.value,
                loading: false,
                "has-more": false,
                "view-mode": viewMode.value,
                onWallpaperClick: viewWallpaper
              }, null, 8, ["wallpapers", "view-mode"])
            ]))
  ]))
}
}

})